// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import TomselectController from "./tomselect_controller"
application.register("tomselect", TomselectController)

import ProjectFundingController from "./project_funding_controller"
application.register("project-funding", ProjectFundingController)

import PublicationFieldsController from "./publication_fields_controller"
application.register("publication-fields", PublicationFieldsController)

import NestedIdentifiersController from "./nested_identifiers_controller"
application.register("nested-identifiers", NestedIdentifiersController)

import FilterSearchController from "./filter_search_controller"
application.register("filter-search", FilterSearchController)

import CountrySelectController from "./country_select_controller"
application.register("country-select", CountrySelectController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import IndexedToggleController from "./indexed_toggle_controller"
application.register("indexed-toggle", IndexedToggleController)

import QuartileSelectorController from "./quartile_selector_controller"
application.register("quartile-selector", QuartileSelectorController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

